var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"l-upload",attrs:{"action":_vm.actionUrl,"data":_vm.data,"headers":_vm.headers,"before-upload":_vm.beforeUpload,"show-file-list":_vm.showFileList,"on-success":_vm.handleSuccess,"on-error":_vm.handleError}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }